







import { Vue, Component, Emit } from 'vue-property-decorator'

@Component({
  name: 'ScrollTopButton'
})
export default class ScrollTopButton extends Vue {
  @Emit('scrollTop') scrollTop () { return true }

  goTop () {
    window.scrollTo(0, 0)
    this.scrollTop()
  }
}
